import { Trash2, Users, X } from 'lucide-react'

interface FaceSelectionToolbarProps {
  count: number
  onGroup: () => void
  onDelete: () => void
  onCancel: () => void
}

export default function FaceSelectionToolbar({
  count,
  onGroup,
  onDelete,
  onCancel,
}: FaceSelectionToolbarProps) {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-card border border-border rounded-xl shadow-2xl px-5 py-3">
      <span className="text-sm font-medium text-foreground">
        {count} face{count !== 1 ? 's' : ''} selected
      </span>
      <div className="w-px h-6 bg-border" />
      <button
        onClick={onGroup}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white transition-colors"
      >
        <Users size={14} />
        Group as Person
      </button>
      <button
        onClick={onDelete}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors"
      >
        <Trash2 size={14} />
        Delete
      </button>
      <button
        onClick={onCancel}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <X size={14} />
        Cancel
      </button>
    </div>
  )
}
